export const OFFLINE_QUICK_ACTIONS = [
  { label: "Livestock Operations", to: "/field/livestock" },
  { label: "Feed Animals", to: "/field/livestock?action=feeding" },
  { label: "Water Check", to: "/field/livestock?action=water" },
  { label: "Pen Cleaning", to: "/field/capture?mode=form&category=cleaning" },
  { label: "Health Check", to: "/field/livestock?action=health_inspection" },
  { label: "Weight Recording", to: "/field/livestock?action=weigh" },
  { label: "Incident Report", to: "/field/capture?mode=incident" },
  { label: "Inventory Usage", to: "/field/capture?mode=inventory" },
  { label: "Forms & Assessments", to: "/field/capture?mode=form" },
  { label: "Machinery Inspection", to: "/field/capture?mode=form&category=equipment_inspection" },
];

export const OFFLINE_FIELD_ACTION_KEYS = new Set(["feeding", "water", "health_inspection", "weigh"]);
export const OFFLINE_CAPTURE_MODES = new Set(["incident", "inventory", "form"]);
export const OFFLINE_FORM_CATEGORIES = new Set(["cleaning", "equipment_inspection"]);

export function permittedFieldAction(requestedAction, actions, allowedPermissions) {
  if (!OFFLINE_FIELD_ACTION_KEYS.has(requestedAction)) return null;
  const action = actions.find((item) => item.key === requestedAction);
  return action && allowedPermissions?.has(action.perm) ? action.key : null;
}

export function initialCaptureSelection(searchParams) {
  const requestedMode = searchParams.get("mode");
  const mode = OFFLINE_CAPTURE_MODES.has(requestedMode) ? requestedMode : "incident";
  const requestedCategory = searchParams.get("category");
  const category = mode === "form" && OFFLINE_FORM_CATEGORIES.has(requestedCategory) ? requestedCategory : null;
  return { mode, category };
}

export function templatesForCategory(templates, category) {
  if (!category) return templates || [];
  return (templates || []).filter((template) => template.category === category);
}

export function captureSelectionPermitted(mode, category, actions) {
  const allowed = actions instanceof Set ? actions : new Set(actions || []);
  if (mode === "incident") return allowed.has("incident");
  if (mode === "inventory") return allowed.has("inventory_use");
  if (mode !== "form" || !allowed.has("forms")) return false;
  return category !== "cleaning" || allowed.has("clean");
}
